module.exports = __webpack_public_path__ + "img/tuzukai.71bcf3b2.jpg";